import { useNavigate, useParams } from 'react-router-dom';
import { Ll144Assessment } from '../components/features/Ll144Assessment/Ll144Assessment';
import { PATHS } from '../constants/Paths.constants';
import { LeftArrow } from '../icons/SvgIcons';
import { AppLayout } from '../layout/AppLayout';
import { DashboardLayout } from '../layout/DashboardLayout';

export function Ll144AssessmentPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(PATHS.AI_SYSTEMS);
  };

  return (
    <AppLayout>
      <DashboardLayout title="AI Systems">
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm flex-1 max-w-none w-full flex flex-col p-4 h-[calc(100vh_-_160px)]">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={handleBack}
              id="ll144-assessment-back-button"
              data-testid="ll144-assessment-back-button"
              className="flex gap-2 items-center"
            >
              {LeftArrow()}
              <div className="text-gray-950 font-medium">AI Systems</div>
            </button>
            <div className="text-gray-950 font-medium">
              NYC Local Law 144 Assessment
            </div>
          </div>
          <div className="overflow-y-auto h-full flex flex-col gap-5">
            {id ? <Ll144Assessment aiSystemId={id} /> : null}
          </div>
        </div>
      </DashboardLayout>
    </AppLayout>
  );
}
